import React from "react";
import { useSelector } from "react-redux";
import { selectAuth } from "../../components/auth/auth.selector";
import SubscriptionExtenstionStructure from "../../components/subscription-extention/SubscriptionExtenstionStructure";
import HelmetWrapper from "../../HelmetWrapper";
import { Container } from "react-bootstrap";

export default function SubscriptionExtension() {
  const authData = useSelector(selectAuth);
  const userInfoData = authData?.user || {};

  return (
    <HelmetWrapper title="WTF: Subscription Extension">
      <Container className="bg-cloud-k px-50px" fluid>
        <SubscriptionExtenstionStructure userInfoData={userInfoData} />
      </Container>
    </HelmetWrapper>
  );
}
